import {connect} from '@modifi/redux'
import ConfirmMatchDialog from './ConfirmMatchDialog'
import {
  selectAggregateMatchPending,
  selectAggregateMatchCompleted,
  aConfirmMatch,
  aCleanupMatch,
} from '../../store'
import {selectSplitPending} from '../../../../modules/split-transaction'

const mapStateToProps = state => ({
  pending: selectAggregateMatchPending(state) || !!selectSplitPending(state),
  matchCompleted: selectAggregateMatchCompleted(state),
})

const mapDispatchToProps = {
  confirmMatch: aConfirmMatch,
  cleanupMatch: aCleanupMatch,
}

export const DIALOG_NAME = 'dialog-confirm-match'

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmMatchDialog)
